import { Body, Controller, Injectable, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from 'packages/backend-utils/src/lib/exception-handling/application-exception-handler';
import { ReportingRepository } from './repositories/reporting.repository';
import { StockInRepository } from './repositories/stock-in.repository';
import { StockInService } from './stock-in.service';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { CommonResponseModel } from '@needle-management/shared-models'
import { StockOutDto } from './dto/stock-out.dto';

@ApiTags('stock-in')
@Controller('stock-in')
@Injectable()
export class StockInController {
    constructor(
        private readonly stockInService: StockInService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
        
      ) {}


      @Post('/stockIn')
      async stockIn(@Body() dto: any): Promise<CommonResponseModel> {
        try {
          return await this.stockInService.stockIn(dto);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
      }

      @Post('/getStockReported')
      async getStockReported(): Promise<CommonResponseModel> {
          try {
            return await this.stockInService.getStockReported();
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }

      @Post('/getStock')
      async getStock(): Promise<CommonResponseModel> {
          try {
            return await this.stockInService.getStock();
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }

      
      @Post('/stockOut')
      async stockOut(@Body() req: any): Promise<CommonResponseModel> {
          try {
            return await this.stockInService.stockOut(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }




      @Post('/getStockInfoByDateRange')
      @ApiBody({
        schema: {
         type: 'object',
          properties: {
          startDate: { type: 'string', format: 'date-time', example: '2025-05-01T00:00:00Z' },
          endDate: { type: 'string', format: 'date-time', example: '2025-05-10T23:59:59Z' },
           },
          required: ['startDate', 'endDate'],
          },
      })
      async getStockInfoByDateRange(@Body() req:{startDate: Date, endDate: Date}): Promise<CommonResponseModel> {
        
          try {
            return await this.stockInService.getStockInfoByDateRange(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }

       @Post('/getAllStockOut')
      async getAllStockOut(@Body()req: any): Promise<CommonResponseModel> {
          try {
            return await this.stockInService.getAllStockOut(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }

}
